import {Tab} from 'presentation/components/HeaderTabNavigation/types';
import {MyHospitalizationFlowEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';

const {tabsName} = translations['pt-br'].privateFlow.myHospitalization.exams;

export const tabs: Tab[] = [
	{
		route: MyHospitalizationFlowEnum.EXAMS,
		name: tabsName.resultsReleased,
	},
	{
		route: MyHospitalizationFlowEnum.REQUESTED_EXAMS,
		name: tabsName.requestedTests,
	},
];
